import { render } from "./Prediction.vue?vue&type=template&id=773482a1"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__